import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";
import { WeddingLoanCalculator } from "@/components/loan/wedding/WeddingLoanCalculator";
import { WeddingHeroBanner } from "@/components/loan/wedding/WeddingHeroBanner";
import { WeddingApplicationSteps } from "@/components/loan/wedding/WeddingApplicationSteps";
import { WeddingThemeSection } from "@/components/loan/renovation/WeddingThemeSection";
import { WeddingLoanOptions } from "@/components/loan/wedding/WeddingLoanOptions";
import { WeddingCallToAction } from "@/components/loan/wedding/WeddingCallToAction";
import EnhancedSeoMetadataComponent from "@/components/common/EnhancedSeoMetadata";
import { getEnhancedSeoDataForRoute } from "@/utils/enhancedSeoUtils";

const HaalainaPage = () => {
  const isMobile = useIsMobile();
  const seoData = getEnhancedSeoDataForRoute("/lainat/haalaina");
  
  // Fade in animation variant
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
      }
    })
  };
  
  return (
    <div className="min-h-screen bg-white">
      <EnhancedSeoMetadataComponent
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonicalUrl="https://lainasampo.fi/lainat/haalaina"
        schema={seoData.schema}
      />
      
      <div className="subpage-container py-4 md:py-8">
        <motion.div
          initial="hidden"
          animate="visible"
          custom={0}
          variants={fadeIn}
          className="px-4 md:px-0"
        >
          <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-pink-700">Häälaina</h1>
        </motion.div>
        
        <WeddingHeroBanner />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-12 px-4 md:px-0">
          <motion.div initial="hidden" animate="visible" custom={2} variants={fadeIn}>
            <WeddingLoanCalculator />
          </motion.div>
          
          <WeddingApplicationSteps />
        </div>
        
        <div className="px-4 md:px-0">
          <WeddingThemeSection />
          
          <WeddingLoanOptions />
          
          <WeddingCallToAction />
        </div>
      </div>
    </div>
  );
};

export default HaalainaPage;
